import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Music, Quote } from "lucide-react";
import { getEpk, resolveAsset } from "@/lib/afmApi";
import { Logo } from "@/components/Logo";
import { Loading } from "@/components/common";

export default function EpkPublic() {
  const { slug } = useParams();
  const [epk, setEpk] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => { getEpk(slug).then((d) => { setEpk(d); setStatus("ok"); }).catch(() => setStatus("error")); }, [slug]);

  if (status === "loading") return <div className="min-h-screen bg-[#0a0a0a]"><Loading label="Cargando EPK…" /></div>;
  if (status === "error") return <div className="flex min-h-screen flex-col items-center justify-center bg-[#0a0a0a] text-white"><Logo variant="white" imgClassName="h-12 w-auto" /><p className="mt-6 text-sm text-slate-400">EPK no disponible.</p></div>;

  const photos = epk.photos || [];
  const press = epk.press || [];

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white" data-testid="epk-public">
      <div className="mx-auto max-w-4xl px-5 py-14">
        <div className="mb-10 flex justify-center"><Logo variant="white" imgClassName="h-9 w-auto object-contain" /></div>

        <header className="flex flex-col items-center gap-5 text-center">
          <div className="flex h-28 w-28 items-center justify-center overflow-hidden rounded-full border border-white/10 bg-white/5">
            {epk.avatar_url ? <img src={resolveAsset(epk.avatar_url)} alt={epk.name} className="h-full w-full object-cover" /> : <Music className="h-10 w-10 text-white/30" />}
          </div>
          <div>
            <h1 className="font-serif text-4xl font-extrabold tracking-tight sm:text-5xl" data-testid="epk-name">{epk.name}</h1>
            {epk.featured_release?.title && <p className="mt-2 text-sm font-semibold uppercase tracking-[0.18em] text-[#FF6b6b]">Último lanzamiento · {epk.featured_release.title}</p>}
          </div>
        </header>

        {epk.bio && (
          <section className="mx-auto mt-12 max-w-2xl" data-testid="epk-bio">
            <h2 className="mb-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500">Biografía</h2>
            <p className="text-lg leading-relaxed text-slate-200">{epk.bio}</p>
          </section>
        )}

        {press.length > 0 && (
          <section className="mt-12" data-testid="epk-press">
            <h2 className="mb-4 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500">Prensa</h2>
            <div className="grid gap-3 sm:grid-cols-2">
              {press.map((p, i) => (
                <div key={i} className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/5 p-4">
                  <Quote className="h-4 w-4 shrink-0 text-[#AC3333]" />
                  <span className="text-sm text-slate-200">{typeof p === "string" ? p : p.quote || p.name}</span>
                </div>
              ))}
            </div>
          </section>
        )}

        {photos.length > 0 && (
          <section className="mt-12" data-testid="epk-photos">
            <h2 className="mb-4 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500">Galería</h2>
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
              {photos.map((ph, i) => (
                <div key={i} className="aspect-square overflow-hidden rounded-xl border border-white/10 bg-white/5">
                  <img src={resolveAsset(typeof ph === "string" ? ph : ph.url)} alt={`foto-${i}`} className="h-full w-full object-cover" />
                </div>
              ))}
            </div>
          </section>
        )}

        <p className="mt-16 text-center text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">Tecnología por SONA</p>
      </div>
    </div>
  );
}
